type Props = {
  id: string;
  name: string;
  email: string;
};

export const update = ({ id, name, email }: Props) => {
  if (window.Intercom) {
    window.Intercom('update', {
      email,
      name,
      user_id: id,
    });
  }
};

export const open = () => {
  if (window.Intercom) {
    window.Intercom('show');
  }
};

export const openNewMessage = (message: string) => {
  if (window.Intercom) {
    window.Intercom('showNewMessage', message);
  }
};

export const hide = () => {
  if (window.Intercom) {
    window.Intercom('hide');
  }
};

export const shutdown = () => {
  if (window.Intercom) {
    window.Intercom('shutdown');
  }
};

export const boot = () => {
  if (window.Intercom) {
    window.Intercom('boot', {
      app_id: import.meta.env.VITE_APP_INTERCOM_ID,
      custom_launcher_selector: '#chatbot_cookdash',
      hide_default_launcher: true,
      vertical_padding: 90,
    });
  }
};

export default open;
